var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletDisconnectedDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 20C4.9 20 3.95833 19.6083 3.175 18.825C2.39167 18.0417 2 17.1 2 16V8C2 6.9 2.39167 5.95833 3.175 5.175C3.95833 4.39167 4.9 4 6 4H18C19.1 4 20.0417 4.39167 20.825 5.175C21.6083 5.95833 22 6.9 22 8V16C22 17.1 21.6083 18.0417 20.825 18.825C20.0417 19.6083 19.1 20 18 20H6ZM6 8.25H18C18.4833 8.25 18.9375 8.325 19.3625 8.475C19.7875 8.625 20.1667 8.84167 20.5 9.125V8C20.5 7.3 20.2583 6.70833 19.775 6.225C19.2917 5.74167 18.7 5.5 18 5.5H6C5.3 5.5 4.70833 5.74167 4.225 6.225C3.74167 6.70833 3.5 7.3 3.5 8V9.125C3.83333 8.84167 4.2125 8.625 4.6375 8.475C5.0625 8.325 5.51667 8.25 6 8.25ZM3.575 11.65L15.5 14.525C15.6167 14.5583 15.7375 14.5625 15.8625 14.5375C15.9875 14.5125 16.0917 14.4583 16.175 14.375L20.175 11.025C19.9583 10.6417 19.6583 10.3333 19.275 10.1C18.8917 9.86667 18.4667 9.75 18 9.75H6C5.41667 9.75 4.9 9.92917 4.45 10.2875C4 10.6458 3.70833 11.1 3.575 11.65Z",
    fill: "#282A30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletDisconnectedDark);
export default __webpack_public_path__ + "static/media/wallet_disconnected_dark.18eefcbfc2c35c6c07ce22f2f77e8685.svg";
export { ForwardRef as ReactComponent };